import { render, staticRenderFns } from "./recruitCen.vue?vue&type=template&id=59996458&scoped=true"
import script from "./recruitCen.vue?vue&type=script&lang=js"
export * from "./recruitCen.vue?vue&type=script&lang=js"
import style1 from "./recruitCen.vue?vue&type=style&index=1&id=59996458&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59996458",
  null
  
)

export default component.exports